import React from 'react';
import { Card, CardContent, Typography, Box, Grid, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { NoticiaList } from '../../../../typesSite/noticia/Noticia';
import configSiteUrls from '../../configs/configSiteUrls';
import { gerarUrlCapa } from '../noticia/create/gerarUrlCapa';

interface NoticiaCardProps {
  noticias: NoticiaList[];
  isFetching?: boolean;
}

export default function NoticiaHomeCardForm({ noticias, isFetching }: NoticiaCardProps) {
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    event.preventDefault();
    navigate(`${configSiteUrls.SITE_NOTICIA_PUBLIC_VIEW_LK}${id}`);
  };

  if (isFetching) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2
        }}
      >
        <CircularProgress />
        <Typography variant="body2" color="textSecondary">Carregando últimas notícias...</Typography>
      </Box>
    );
  }

  if (!noticias || noticias.length === 0) {
    return  <Typography variant="body2" color="textSecondary">Erro: Últimas notícias não carregadas!</Typography>;
  }

  return (
    <>
      <Box sx={{ mb: 3 }}>
        <Typography
          color="primary"
          sx={{
            fontWeight: 700,
            fontSize: { xs: '20px', sm: '24px', md: '28px' }, // aumento significativo
            lineHeight: { xs: '26px', sm: '30px', md: '34px' }, // proporcional ao tamanho da fonte
            mt: 1
          }}
        >
          Últimas Notícias
        </Typography>
      </Box>

      <Grid container spacing={2}>
        {noticias.map(noticia => (
          <Grid
            item
            key={noticia.id}
            xs={12} // Mobile: ocupa toda largura
            sm={6} // Tablet: ocupa metade
            md={4} // Desktop: 3 cards por linha
          >
            <Card sx={{ width: '100%' }}>
              <a href="#" onClick={e => handleClick(e, noticia.id)} style={{ textDecoration: 'none', color: 'inherit' }}>
                <CardContent sx={{ p: 1 }}>
                  <Box
                    component="img"
                    src={gerarUrlCapa(noticia.imagem || '', 'NOTICIA')}
                    alt={noticia.imagem}
                    sx={{
                      width: '100%',
                      height: { xs: '200px', sm: '180px', md: '180px' },
                      borderRadius: 2,
                      objectFit: 'cover'
                    }}
                  />

                  <Typography
                    color="primary"
                    sx={{
                      fontWeight: 700,
                      fontSize: { xs: '15px', sm: '16px', md: '17px' },
                      lineHeight: '22px',
                      mt: 1
                    }}
                  >
                    {noticia.titulo}
                  </Typography>

                  <Typography variant="caption" color="secondary" sx={{ textAlign: 'right', display: 'block' }}>
                    {noticia?.dataHoraCriacao ? new Date(noticia?.dataHoraCriacao).toLocaleDateString() : ''}
                  </Typography>
                </CardContent>
              </a>
            </Card>
          </Grid>
        ))}
      </Grid>
    </>
  );
}
